export const OPENAI_ADS_CONSENT_KEY = 'printeam:openai-ads-consent:v1';
export const OPENAI_ADS_CONSENT_EVENT = 'printeam:openai-ads-consent-change';
export const OPENAI_ADS_TECHNICAL_RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
export const OPENAI_ADS_TOKEN_PATTERN = /^[0-9a-f]{32}$/;

export function readOpenAIAdsPreference(browser, now = Date.now()) {
  try {
    const saved = JSON.parse(browser?.localStorage?.getItem(OPENAI_ADS_CONSENT_KEY) || 'null');
    if (saved?.version !== 1 || !['granted', 'denied'].includes(saved.choice)
      || !Number.isFinite(saved.updated_at) || saved.updated_at > now
      || now - saved.updated_at >= OPENAI_ADS_TECHNICAL_RETENTION_MS
      || (saved.choice === 'granted' && !OPENAI_ADS_TOKEN_PATTERN.test(saved.consent_token))) return null;
    return saved;
  } catch (_) { return null; }
}
